/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-10 14:41:14
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-07-15 15:34:36
 * @FilePath: \MPC-monorepo\features\mpc-common\src\features\MPCDemand\enum.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useMemo } from 'react';
import { Tag } from '@bedrock/components';

export const contractMethodOptions = [
    {
        name: '复用合同',
        value: 'REUSE'
    },
    {
        name: '新建合同-自动生成合同',
        value: 'NEW_CREATE_ONLINE'
    },
    {
        name: '新建合同-人工上传合同',
        value: 'NEW_CREATE_MANUAL'
    },
    {
        value: 'NO_NEED',
        name: '无需合同',
    },
]

export function getContractMethodOptions(checked_amount: number) {
    return [
        {
            name: '复用合同',
            value: 'REUSE'
        },
        {
            name: '新建合同-自动生成合同',
            value: 'NEW_CREATE_ONLINE'
        },
        {
            name: '新建合同-人工上传合同',
            value: 'NEW_CREATE_MANUAL'
        },
        {
            value: 'NO_NEED',
            showName: '无需合同',
            name: <>
                <div>无需合同</div>
                <div>中选金额&lt;50,000.00人民币时可选择</div>
            </>,
            disabled: checked_amount > 50000,
        },
    ]
}

export function ContractMethodTag(props: {
    value: string;
}) {
    const { value } = props;
    const tag = useMemo(() => {
        if(!value) return '--';
        const tagText = contractMethodOptions.find(item => item.value === value)?.name;
        switch (value) {
            case 'REUSE':
                return <Tag size="small" color="light-blue" text={tagText} />;
            case 'NEW_CREATE_ONLINE':
            case 'NEW_CREATE_MANUAL':
                return <Tag size="small" color="light-green" text={tagText} />;
            case 'NO_NEED':
            default:
                return <Tag size="small" color="light-grey" text={tagText} />;
        }
    }, [value]);
    return <>{tag}</>;
}

export const booleanOptions = [
    {
        name: '是',
        value: true
    },
    {
        name: '否',
        value: false
    },
]
